import { vehicleDisplay } from './types';
import type { VehicleListItem } from './types';

export type DueReminderDueReason = 'km' | 'tiempo' | null;

export type DueReminderRow = {
  id: string;
  label: string;
  vehicleId: string;
  vehicleLabel: string;
  reasonLabel: string;
};

export function dueReasonLabel(reason: DueReminderDueReason): string {
  if (reason === 'km') return 'Venció por km';
  if (reason === 'tiempo') return 'Venció por fecha';
  return 'Vencido';
}

export function buildDueReminderRows(
  due: { id: string; vehicleId: string; label: string; dueReason: DueReminderDueReason }[],
  vehicles: VehicleListItem[],
): DueReminderRow[] {
  const byId = new Map(vehicles.map((v) => [v.id, v]));
  return due.map((r) => {
    const v = byId.get(r.vehicleId);
    return {
      id: r.id,
      label: r.label,
      vehicleId: r.vehicleId,
      vehicleLabel: v ? vehicleDisplay(v) : 'Vehículo',
      reasonLabel: dueReasonLabel(r.dueReason),
    };
  });
}
